import Links from '@/shared/constants/navegacao';
import { colunasGeral, colunasDefensor, colunasEstagiarios, colunasUsuarios, colunasColaboradores } from './index_columns';
import { useEffect, useMemo } from 'react';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { PeopleDataTable } from '../components/PeopleDataTable';

interface Props {
  tipo: 'todos' | 'defensor' | 'estagiario' | 'colaborador' | 'usuario'
}

export default function PersonIndexPage({ tipo }: Props) {
  const { setActions } = useBreadcrumbActions();

  const { titulo, colunas, createLink } = useMemo(() => {
    switch (tipo) {
      case 'colaborador':
        return {
          titulo: 'Colaboradores',
          colunas: colunasColaboradores,
          createLink: `${Links.Colaborador_Criar}`
        };
      case 'defensor':
        return {
          titulo: 'Defensores',
          colunas: colunasDefensor,
          createLink: `${Links.Defensor_Criar}`
        };
      case 'estagiario':
        return {
          titulo: 'Estagiários',
          colunas: colunasEstagiarios,
          createLink: `${Links.Estagiario_Criar}`
        };
      case 'usuario':
        return {
          titulo: 'Usuários',
          colunas: colunasUsuarios,
          createLink: `${Links.Usuario_Criar}`
        };
      default:
        return {
          titulo: 'Pessoas',
          colunas: colunasGeral,
          createLink: `${Links.Pessoa_Criar}`
        };
    }
  }, [tipo]);

  // Registra os botões no Breadcrumb (Ação Primária, Ação Secundária; sem listagem)
  useEffect(() => {
    const config = {
      primary: { label: 'Cadastrar', onClick: () => { }, href: createLink },
      ...(tipo === 'usuario' && { secondary: { label: 'Sessões', onClick: () => { }, href: Links.Sessoes_Index } }),
    };
    setActions(config);
    return () => setActions({});
  }, [setActions, createLink, tipo]);

  return (
    <div className="row">
      <div className="col-12">
        <h3 className="pt-4">{titulo}</h3>
        <span className="blockquote-footer pb-4 text-end">
          {titulo} cadastrados no sistema.
        </span>
      </div>

      <hr className="pb-4" />

      <PeopleDataTable tipo={tipo} columns={colunas} />
    </div>
  );
}